import React from 'react';
import classNames from 'classnames';
import StarIcon from './star-icon';
import styles from './rating-stars.scss';

type Props = {
  a11yLabel?: string;
};

export const OneStar = ({ a11yLabel }: Props) => {
  return (
    <span className={styles.root}>
      {a11yLabel && <span className={styles.visuallyHidden}>{a11yLabel}</span>}
      <span aria-hidden="true" className={styles.innerContainer}>
        <StarIcon className={classNames(styles.icon, styles.full)} />
      </span>
    </span>
  );
};
